// extracted by mini-css-extract-plugin
export var container = "_4w-0";
export var disabled = "_4w-4";
export var fullWidth = "_4w-3";
export var lined = "_4w-1";
export var selected = "_4w-5";
export var tab = "_4w-2";